function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("title", null, "Checkmark");

var _ref3 =
/*#__PURE__*/
React.createElement("g", {
  id: "Checkmark",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("path", {
  d: "M24.0000206,4.09090904 L24.0000206,4.09090854 C23.9988256,3.78966491 23.7536503,3.54642709 23.4524061,3.54762218 C23.3050106,3.54820687 23.1641263,3.60841909 23.0618377,3.714546 L23.0618377,3.714546 L8.72729219,18.583637 L0.932746704,10.794546 L0.932746713,10.794546 C0.720613985,10.5806559 0.375253984,10.5792317 0.161364892,10.7913648 C0.0573167096,10.8945582 -0.000832017932,11.0352779 2.05275259e-05,11.1818186 L2.05149272e-05,11.1818208 C-0.000817139622,11.3268042 0.0561019697,11.4661559 0.15820397,11.569093 L8.34002219,19.7509112 L8.34002219,19.7509112 C8.55063091,19.9663024 8.89597128,19.970179 9.11136037,19.7595705 C9.11427915,19.7567166 9.11716581,19.7538299 9.12001973,19.7509112 L9.12001973,19.7509112 L23.8472925,4.47818383 L23.8472925,4.47818383 L23.8472925,4.47818383 C23.9473987,4.37436037 24.0023113,4.23511564 24.0000182,4.09090946 L24.0000206,4.09090904 Z",
  id: "Checkmark",
  fill: "#4431AF"
}));

var SvgCheckPlain = function SvgCheckPlain(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgCheckPlain, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/check-plain.48b977be.svg";
export { ForwardRef as ReactComponent };